export default {
  collections: [],
  homePagination: {},
  contentCollections: [],
  banners: [],
};
